import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { UpdateSiteName } from '../editSite/updateSiteName';
import { DeleteRecord } from '../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useListBackNavigation } from '../../../hooks/listNavigation';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/sites/siteDetailsHeader.css';

const SiteDetailsHeader = () => {

    const { t } = useTranslation();
    const { goBack, goToList } = useListBackNavigation('/dashboard/sites');
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const siteDetailsData = useSelector((state) => state.SiteDetailsData);

    const hasMachineUpdatePermission = useHasPermission('site_update');
    const hasMachineDeletePermission = useHasPermission('site_delete');

    const [errMsg, setErrMsg] = useState('');
    const [modifyName, setModifyName] = useState(false);
    const [deleteSite, setDeleteSite] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openActionMenu = Boolean(anchorEl);

    const handleDeleteSite = async () => {
        try {
            const response = await axios.delete(`site/${siteDetailsData?.id}`);
            if (response.status === 200 || response.status === 201) {
                setDeleteSite(false);
                goToList();
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error.message || "Erreur lors de la suppression du site");
            console.error('Error deleting site:', error);
            CustomErrorLogger(error, "Delete Site");
        }
    }

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = goBack;

    return (
        <Box className="siteDetailsHeader_mainBox">
            <Box className="siteDetailsHeader_firstPart">
                <Iconify className='siteDetailsHeader_back_icon' icon={"material-symbols:arrow-back"} onClick={handleGoBack} />
                <Typography className="siteDetailsHeader_title">{siteDetailsData?.name}</Typography>
                {hasMachineUpdatePermission && <Iconify className='siteDetailsHeader_edit_icon' icon={"ic:outline-edit"} onClick={() => setModifyName(true)} />}
                {siteDetailsData?.description}
            </Box>
            <Box className="siteDetailsHeader_secondPart">
                {isDesktop && hasMachineDeletePermission &&
                    <Box className="siteDetailsHeader_action_box" onClick={() => setDeleteSite(true)}>
                        <Iconify className='siteDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                        <Typography className="siteDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && <Iconify
                    className='siteDetailsHeader_dots_icon'
                    icon="vaadin:ellipsis-dots-v"
                    id="userPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />}
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {!isDesktop && hasMachineDeletePermission &&
                        <MenuItem className='siteDetailsHeader_menuItem' onClick={() => setDeleteSite(true)}>
                            <Iconify className='siteDetailsHeader_delete_icon' icon="ic:outline-delete" />
                            <Typography className="siteDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>

            {modifyName &&
                <UpdateSiteName
                    modifyName={modifyName}
                    setModifyName={setModifyName}
                />
            }
            {deleteSite &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deleteSite}
                    setOpenDelete={setDeleteSite}
                    handleDelete={handleDeleteSite}
                    title="Êtes-vous sûr de vouloir supprimer ce site ?"
                />
            }
        </Box>
    );
}

export default SiteDetailsHeader;